import axios from "axios";
import Cookies from "js-cookie";
import router from '../router/index'
import { Message } from "element-ui";

const request = axios.create({
    //baseURL:'/api',
    baseURL: 'http://134.175.70.111:9096/qy-screen-api',
    //跨域配置在config/index里
    withCredentials: false, //跨域时使用凭证，默认带上cookies
    timeout: 5000
})
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    const accessToken = Cookies.get('token') || ''
    config.headers['token'] = accessToken;
    return config
}, error => {
    return Promise.reject(error)
})

request.interceptors.response.use(
    response => {
        // let res = response.data;
        // // 如果是返回的文件
        // if (response.config.responseType === 'blob') {
        //     return res
        // }
        // // 兼容服务端返回的字符串数据
        // if (typeof res === 'string') {
        //     res = res ? JSON.parse(res) : res
        // }
        return response;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)


export default request



// WEBPACK FOOTER //
// ./src/axios/index.js